import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { getReliabilityScoreColors, getReliabilityScorePercent } from './reliabilityScoreConstants';

const STAR_PATH_D =
  'M6.9125 20.25L7.725 16.7375L5 14.375L8.6 14.0625L10 10.75L11.4 14.0625L15 14.375L12.275 16.7375L13.0875 20.25L10 18.3875L6.9125 20.25Z';

const ReliabilityScoreReportBadge = ({ score }) => {
  const displayScore = typeof score === 'number' ? getReliabilityScorePercent(score) : '--';
  const { gradientStart, gradientEnd } = getReliabilityScoreColors(score);
  const isWide = String(displayScore).length >= 3;

  return (
    <Box
      component="span"
      data-testid="reportBadge"
      sx={{
        display: 'inline-flex',
        flexShrink: 0,
        alignItems: 'center',
        gap: '2px',
        height: '31px',
        padding: isWide ? '0 10px' : '0 8px',
        borderRadius: '16px',
        border: '1px solid white',
        background: `linear-gradient(to bottom, ${gradientStart}, ${gradientEnd})`,
        boxSizing: 'border-box',
      }}
    >
      <svg width="10" height="11" viewBox="5 10 10 11" fill="none">
        <path d={STAR_PATH_D} fill="white" />
      </svg>
      <Typography
        component="span"
        sx={{
          color: 'white',
          fontFamily: 'sans-serif',
          fontSize: isWide ? '13px' : '14px',
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        {displayScore}
      </Typography>
    </Box>
  );
};

ReliabilityScoreReportBadge.propTypes = {
  score: PropTypes.number,
};

export default ReliabilityScoreReportBadge;
